import '../scss/audioDetail.scss';
import $ from 'jquery';
import Lazyload from 'lazyload';

import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';
import {
  browerVersion,
  getBrowerAppId,
  getSingleValueFromInput,
  getUrlQuery,
  isHideDownloadGuide,
  uuid,
} from './utils';
import 'swiper/css';
import {
  fetchAddReadCountByLog,
  fetchAddSubscribe,
  fetchCommentList,
  fetchContentPropertie,
  fetchDelSubscribe,
  fetchMediaInfoV3,
  fetchSiteJson,
} from '../apis/api';
import initWxSdk from './wxSdk';
import { getUserInfo } from './appSdk';
import YouMeng from './YouMeng';
import NanFang from './NanFang';

Swiper.use([FreeMode]);
let appId = uuid();
let userId = '';
const version = browerVersion();
const commentRight = require('../assets/images/comment-right.png');
const commentLike = require('../assets/images/comment-like.png');

const formatLess10 = (num: number) => {
  return num < 10 ? `0${num}` : `${num}`;
};
/**
 * 计算当前时间长度的时:分:秒
 * @param time
 * @returns
 */
const formatTime = (time: number) => {
  const timeInt = Math.floor(time);
  const h = Math.floor(timeInt / 3600);
  const m = Math.floor((timeInt / 60) % 60);
  const s = Math.floor(timeInt % 60);
  return `${formatLess10(h)}:${formatLess10(m)}:${formatLess10(s)}`;
};

let step = 0;
let initX = 0;
const initDuration = (time: number) => {
  const duration = formatTime(time);
  $('.audio-duration').text(duration);
  $('.audio-current-duration').show();
  const rect = $('.audio-progress-bar')[0].getBoundingClientRect();
  initX = rect.x;
  step = Math.floor((time / rect.width) * 10000) / 10000;
};

let audio: HTMLAudioElement;
/**
 * 设置进度条长度
 * @param audioBox
 * @param clientX
 * @returns
 */
const setProgress = (clientX: number) => {
  if (!clientX) {
    return;
  }
  const moveX = clientX - initX;
  $('.audio-active-progress').css({ width: `${moveX}px` });
  audio.currentTime = Math.floor(moveX * step);
  $('.audio-current').text(formatTime(audio.currentTime));
};

let isTouching = false;
/**
 * 监听进度条touchstart/mousedown事件
 * @param evt
 */
const audioTouchStart = (evt: Event) => {
  isTouching = true;
  let clientX = 0;
  if (evt.type === 'touchstart') {
    clientX = (evt as TouchEvent).touches[0].clientX;
  } else if (evt.type === 'mousedown') {
    clientX = (evt as MouseEvent).clientX;
  }
  setProgress(clientX);
};
/**
 * 监听进度条touchmove/mousemove事件
 * @param evt
 * @returns
 */
const audioTouchMove = (evt: Event) => {
  if (!isTouching) {
    return;
  }
  let clientX = 0;
  if (evt.type === 'touchmove') {
    clientX = (evt as TouchEvent).touches[0].clientX;
  } else if (evt.type === 'mousemove') {
    clientX = (evt as MouseEvent).clientX;
  }
  setProgress(clientX);
};
/**
 * 监听进度条touchend/mouseup事件
 * @returns
 */
const audioTouchEnd = () => {
  isTouching = false;
};

const initAudio = () => {
  const audioSrc = getSingleValueFromInput('audioSrc');
  if (audioSrc) {
    audio = new Audio(audioSrc);
    $('.audio-play-btn').on('click', () => {
      audio.play();
    });
    $('.audio-pause-btn').on('click', () => {
      audio.pause();
    });
    audio.onplay = () => {
      $('.audio-play-btn').hide();
      $('.audio-pause-btn').show();
    };
    audio.onpause = () => {
      $('.audio-play-btn').show();
      $('.audio-pause-btn').hide();
    };
    audio.onended = () => {
      audio.currentTime = 0;
      $('.audio-active-progress').css({
        width: `0px`,
      });
      $('.audio-play-btn').show();
      $('.audio-pause-btn').hide();
    };
    let duration = parseInt(getSingleValueFromInput('audioDuration'), 10) || 0;
    let currentTime = 0;
    if (duration) {
      initDuration(duration);
    }
    audio.ontimeupdate = () => {
      if (!duration) {
        duration = audio.duration;
        initDuration(duration);
      }
      if (isTouching) {
        return;
      }
      const roundCurrentTime = Math.round(audio.currentTime);
      if (roundCurrentTime !== currentTime) {
        currentTime = roundCurrentTime;
        $('.audio-current').text(formatTime(currentTime));
        $('.audio-active-progress').css({
          width: `${Math.round(currentTime / step)}px`,
        });
      }
    };
  }
  const audioProgressBar = document.querySelector('.audio-progress-bar');
  if (audioProgressBar) {
    audioProgressBar.addEventListener('mousedown', audioTouchStart, {
      passive: true,
    });
    audioProgressBar.addEventListener('touchstart', audioTouchStart, {
      passive: true,
    });
    window.addEventListener('mousemove', audioTouchMove, {
      passive: true,
    });
    audioProgressBar.addEventListener('touchmove', audioTouchMove, {
      passive: true,
    });
    window.addEventListener('mouseup', audioTouchEnd, {
      passive: true,
    });
    audioProgressBar.addEventListener('touchend', audioTouchEnd, {
      passive: true,
    });
  }
  const audioPlaybackRateText = document.querySelector(
    '.audio-playback-rate-text',
  );
  const audioPlaybackRate = document.querySelector(
    '.audio-playback-rate',
  ) as HTMLElement;
  const rateArr = ['1.0', '1.25', '1.5', '1.75', '0.75'];
  if (audioPlaybackRate && audioPlaybackRateText) {
    audioPlaybackRateText.addEventListener('click', () => {
      const rate = audioPlaybackRate.innerText;
      const rateIndex = rateArr.findIndex(
        (item) => Number(rate) === Number(item),
      );
      let newRate = '1.0';
      if (rateIndex === -1) {
        audioPlaybackRate.innerText = `${rateArr[0]}`;
      } else {
        newRate = rateArr[(rateIndex + 1) % rateArr.length];
        audioPlaybackRate.innerText = `${
          rateArr[(rateIndex + 1) % rateArr.length]
        }`;
      }
      audio.playbackRate = Number(newRate);
    });
  }
};
/**
 * 生成评论html
 * @param item
 * @returns
 */
const getCommentHtml = (item: RMT.CommentList) => {
  const commentAvatarHtml = `<img class="comment-avatar lazyload" src="${process.env.DEFAULT_AVATAR}" data-src="${item.headImg}" onerror="this.src='${process.env.DEFAULT_AVATAR}'"
    alt="${item.username}">`;
  const commentReplyHtml = `<div class="comment-reply-box">
      <div class="launch-app-btn" name="launch-app-btn" data-style="comment-reply-style">
        <a name="download-link" class="download-link">
          <div class="comment-reply">回复<img style="width: 16px;height: 16px;" src="${commentRight}" alt="回复"></div>
        </a>
      </div>
    </div>`;
  const commentUsernameHtml = `<span class="comment-nickname">${item.username}</span>`;
  const commentLikeHtml = `<div class="like-unlike">
      <div class="comment-like">
        <div class="launch-app-btn" name="launch-app-btn" data-style="like-unlike-style">
          <a name="download-link" class="download-link">
            <img class="comment-like-icon" src="${commentLike}" alt="点赞">
          </a>
        </div>
      </div>
    </div>`;
  const commentHeaderHtml = `<div class="comment-header">${commentUsernameHtml}${commentLikeHtml}</div>`;
  const commentEmotion = `<img class="comment-emotion" src="${item.txt}" />`;
  const commentBodyHtml = `<div class="comment-body">${
    item.emotion ? commentEmotion : item.txt
  }</div>`;
  const commentDetailHtml = `<div class="comment-detail">${commentHeaderHtml}${commentBodyHtml}${commentReplyHtml}</div>`;
  return `<div class="comment-box">${commentAvatarHtml}${commentDetailHtml}</div>`;
};
/**
 * 获取稿件评论
 * @param downloadUrl
 */
const initComment = (downloadUrl: string) => {
  if (!version.myApp) {
    const newsId = getSingleValueFromInput('newsId');
    const siteId = getSingleValueFromInput('siteId');
    fetchCommentList(newsId, siteId, appId).then((res) => {
      if (Number(res.status) === 200 && res.list.length) {
        $('#article-comment').show();
        const commentHtmls = res.list.map((item) => getCommentHtml(item));
        $('#comment-list').html(commentHtmls.join(''));
        $('#article-comment')
          .find('a[name="download-link"]')
          .attr('data-href', downloadUrl);
        if (!version.mobile) {
          $('#article-comment')
            .find('a[name="download-link"]')
            .attr('href', downloadUrl);
        }
        // eslint-disable-next-line no-new
        new Lazyload($('#article-comment').find('.comment-avatar'));
        initWxSdk({
          launchAppBtn: [
            {
              attr: 'class',
              value: 'comment-like',
            },
            {
              attr: 'class',
              value: 'comment-reply-box',
            },
            {
              attr: 'id',
              value: 'more-comment-box',
            },
          ],
        });
      }
    });
  }
};
/**
 * 初始化sitejson
 */
const initSiteJson = () => {
  if (!version.myApp) {
    fetchSiteJson().then((res: Site.SiteJson) => {
      initComment(res.downloadUrl);
      if (isHideDownloadGuide()) {
        return;
      }
      const headerGuideBox = $('#header-guide-box');
      if (!headerGuideBox || !res.name) {
        return;
      }
      // 设置下载链接
      headerGuideBox
        .find('a[name="download-link"]')
        .attr('data-href', res.downloadUrl)
        .attr('alt', res.name);
      // 设置引导图片
      headerGuideBox
        .find('img[name=guide-image]')
        .attr('src', res.guidePic)
        .attr('alt', res.name);
      headerGuideBox.find('img[name=guide-image]').on('load', (evt) => {
        const { clientWidth } = document.body;
        let imageHeight = '';
        let imageWidth = '';
        const { naturalHeight, naturalWidth } =
          evt.currentTarget as HTMLImageElement;
        if (clientWidth > 650) {
          imageWidth = '650px';
          imageHeight = `${(650 / naturalWidth) * naturalHeight}px`;
        } else {
          imageWidth = `${clientWidth}px`;
          imageHeight = `${(clientWidth / naturalWidth) * naturalHeight}px`;
        }
        $(evt.currentTarget).css({
          height: imageHeight,
          width: imageWidth,
        });
        initWxSdk({
          launchAppBtn: [
            {
              attr: 'id',
              value: 'header-guide-box',
            },
          ],
        });
      });
      // 点击关闭按钮的事件
      headerGuideBox.find('img[name="close-guide"]').each((index, el) => {
        $(el).on('click', (evt) => {
          evt.preventDefault();
          evt.stopPropagation();
          headerGuideBox.hide();
        });
      });
    });
  }
};
const addReadCount = () => {
  const newsId = getSingleValueFromInput('newsId');
  const contentType = getSingleValueFromInput('contentType');
  const siteId = getSingleValueFromInput('siteId');
  if (newsId && contentType && siteId) {
    fetchAddReadCountByLog(newsId, Number(contentType), siteId);
  }
};
/**
 * 处理所有媒体号的基础信息
 */
const initAllMedia = () => {
  // 普通媒体号轮播效果
  const notLeaderMediaLinkDoms = $('.media-box-link');
  const notLeaderMediaListDom = $('#media-list');
  if (
    notLeaderMediaLinkDoms &&
    notLeaderMediaLinkDoms.length &&
    notLeaderMediaListDom &&
    notLeaderMediaListDom.length
  ) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const swiper = new Swiper('#media-list', {
      slidesPerView: 'auto',
      freeMode: true,
      centerInsufficientSlides: true,
      breakpoints: {
        320: {
          spaceBetween: 15,
        },
        650: {
          spaceBetween: 20,
        },
      },
    });
  }
  $('.media-leader-subscribe').hide();
  $('.media-leader-del-subscribe').hide();
  $('.media-leader-more').css('display', 'flex');
};

/**
 * 初始化领导媒体号的功能
 * @returns
 */
const initMediaLeader = () => {
  if (version.myApp) {
    const siteId = getSingleValueFromInput('siteId');
    const mediaLeaderLinkDoms = $('.exist-media-leader-link');
    // 获取媒体号基础信息并根据userId判断是否已经关注
    if (userId && mediaLeaderLinkDoms && mediaLeaderLinkDoms.length) {
      const mediaInfoPromises: Promise<false | Media.MediaData>[] = [];
      mediaLeaderLinkDoms.each((_, el) => {
        const { id } = el.dataset;
        if (id) {
          mediaInfoPromises.push(fetchMediaInfoV3(siteId, id, appId, userId));
        } else {
          mediaInfoPromises.push(
            new Promise((resolve) => {
              resolve(false);
            }),
          );
        }
      });
      Promise.all(mediaInfoPromises).then((reslist) => {
        reslist.forEach((item, index) => {
          if (!item) {
            return;
          }
          if (Number(item.isSubscribe)) {
            const el = mediaLeaderLinkDoms[index];
            $(el).find('.media-leader-subscribe').hide();
            $(el).find('.media-leader-del-subscribe').css('display', 'flex');
          }
        });
      });
    }
    // 关注按钮的点击事件，若未登录则调用app登录功能，若已登录则调用接口关注
    $('.media-leader-subscribe').on('click', (evt) => {
      evt.stopPropagation();
      const mediaLeaderDom = $(evt.currentTarget).parents(
        '.exist-media-leader-link',
      );
      const { id } = mediaLeaderDom[0].dataset;
      if (id && userId) {
        fetchAddSubscribe(siteId, id, appId, userId).then((res) => {
          if (Number(res.status) === 200) {
            mediaLeaderDom.find('.media-leader-subscribe').hide();
            mediaLeaderDom
              .find('.media-leader-del-subscribe')
              .css('display', 'flex');
          }
        });
      } else if (id && !userId) {
        getUserInfo((result) => {
          if (result && result.userId) {
            userId = result.userId;
          }
        });
      }
    });
    // 取消关注按钮的点击事件，若未登录则调用app登录功能（逻辑上不存在该事件），若已登录则调用接口取消关注
    $('.media-leader-del-subscribe').on('click', (evt) => {
      evt.stopPropagation();
      const mediaLeaderDom = $(evt.currentTarget).parents(
        '.exist-media-leader-link',
      );
      const { id } = mediaLeaderDom[0].dataset;
      if (id && userId) {
        fetchDelSubscribe(siteId, id, appId, userId).then((res) => {
          if (Number(res.status) === 200) {
            mediaLeaderDom
              .find('.media-leader-subscribe')
              .css('display', 'flex');
            mediaLeaderDom.find('.media-leader-del-subscribe').hide();
          }
        });
      } else if (id && !userId) {
        getUserInfo((result) => {
          if (result && result.userId) {
            userId = result.userId;
          }
        });
      }
    });
  }
};

/**
 * 初始化浏览量
 */
const initReadCount = () => {
  const readLikeNumber = $('#read-like-number');
  const newsId = getSingleValueFromInput('newsId');
  const channelId = getSingleValueFromInput('channelId');
  if (newsId && channelId) {
    fetchContentPropertie(newsId, channelId).then((res) => {
      const { praiseCount, visitCount, isShield, status, isReading } = res;
      if (Number(status) !== 200) {
        return;
      }
      if (isShield === 1) {
        $('#article-comment').remove();
      }
      if (Number(isReading) === 1 && readLikeNumber?.length && version.myApp) {
        $('#read-like-number').removeClass('hidden');
        $('#read-number-text').text(visitCount);
        $('#like-number-text').text(praiseCount);
      }
    });
  }
};
/**
 * 初始化相关活动
 */
const initRelatedActivity = () => {
  if ($('#related-activity')) {
    $('#related-activity').show();
  }
};
(() => {
  const newsId = getSingleValueFromInput('newsId');
  if (version.myApp && version.userId) {
    userId = version.userId;
  }
  initAudio();
  const staticType = getSingleValueFromInput('staticType');
  if (Number(staticType)) {
    initSiteJson();
    getBrowerAppId((browerId) => {
      appId = browerId;
      addReadCount();
      initMediaLeader();
    });
  }
  if (!Number(staticType)) {
    const query = getUrlQuery();
    if (!Number(query.isMobile)) {
      const previewSubtitle = $('.preview-subtitle');
      if (previewSubtitle) {
        previewSubtitle.show();
      }
      const previewKeyword = $('.preview-keyword');
      if (previewKeyword) {
        previewKeyword.show();
      }
      const previewDescription = $('.preview-description');
      if (previewDescription) {
        previewDescription.show();
      }
    }
  }
  // eslint-disable-next-line no-new
  new Lazyload();
  initReadCount();
  initAllMedia();
  YouMeng.initYoumeng();
  YouMeng.initYoumengLog(() => {
    YouMeng.pushRecord(
      { article_id: newsId },
      'gzcmc.xhc.h5.manuscript.view.click',
      'onload',
    );
  });

  NanFang.init().then(() => {
    NanFang.openArticle(newsId);
  });
  initRelatedActivity();
  initWxSdk({
    wxShare: {
      title: getSingleValueFromInput('shareTitle') || document.title,
      desc: getSingleValueFromInput('shareDesc') || '',
      imgUrl: (getSingleValueFromInput('shareImgUrl') ||
        process.env.DEFAULT_SHARE_IMAGE) as string,
    },
  });
})();
